import React from 'react';
import { FarecardCappingPot } from '../../services/types/apitypes';
import { IonIcon, IonItem, IonLabel, IonList } from '@ionic/react';
import { useTranslation } from 'react-i18next';

type FarecardCappingCardCompleteProps = {
  pot: FarecardCappingPot;
  onClick?: () => void;
};

export default function FarecardCappingCardComplete({
  pot,
  onClick,
}: FarecardCappingCardCompleteProps): React.ReactElement {
  const [t] = useTranslation('global');

  return (
    <IonList className="pt-2">
      <IonItem
        lines="none"
        className="ion-no-padding ion-pt-1 pseudo-select pseudo-select-option"
        button={!!onClick}
        onClick={onClick}
        color="primary"
      >
        <IonIcon
          slot="start"
          src="assets/icon/fare-capping-complete-icon.svg"
          className="fare-capping-icon"
        ></IonIcon>
        <IonLabel className="fare-cappin-complete-info">
          <p>
            {t('farecapping.fareCappingEarned')}
          </p>
          <p>{t('farecapping.fareCappingFreeRides')}</p>
        </IonLabel>
      </IonItem>
    </IonList>
  );
}
